import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom';
import queryString from 'query-string'

import stripeLogo from './../../../assets/images/stripeLogo.svg'
import classyLogo from './../../../assets/images/classy_logo.svg'
import salesforceLogo from './../../../assets/images/salesforceLogo.svg'
import zapierLogo from './../../../assets/images/zapierLogo.png'
import networkForGoodLogo from './../../../assets/images/networkForGoodLogo.png'

import { API, Auth } from 'aws-amplify';

// mui
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CheckIcon from '@mui/icons-material/Check';
import Badge from '@mui/material/Badge'

// redux
import { useAppDispatch, useAppSelector } from '../../../hooks'
import { completeConnectedAccountSetup, getFundraisingConnectedAccountLink, getFundraisingOrganizationData } from '../../../managers/redux/slices/fundraising'
import { reloadAuthAccount } from '../../../managers/redux/slices/authAccount'
import InviteTeamMember from '../../../components/dialogs/team/InviteTeamMember'
import { COLORS } from '../../../theme/muiTheme';

import { FundraisingProfile } from '../../../API'
import InviteAmbassador from '../../../components/dialogs/fundraising/InviteAmbassador';
import { getActiveClassyConnections } from '../../../managers/redux/slices/organization';

export default function Integrations(props: any) {

    const history = useHistory()

    // redux
    const dispatch = useAppDispatch()
    const authAccount = useAppSelector(state => state.authAccount)

    const selectedStaffProfile = useAppSelector(state => state.authAccount.selectedStaffProfile)
    const activeClassyConnections = useAppSelector(state => state.organization.activeClassyConnection)
    const cognitoData = useAppSelector(state => state.authAccount.cognitoData)

    async function handlePayoutsLinkClick() {
        const connectedAccountLink = await dispatch(getFundraisingConnectedAccountLink())
        console.log(connectedAccountLink)
        if (connectedAccountLink.payload) {
            window.location.href = connectedAccountLink.payload.url
        }
    }

    useEffect(() => {
        (async () => {
            if (cognitoData) {
                await dispatch(getActiveClassyConnections())
                const qsParams = queryString.parse(window.location.search.split('#')[0])
                if (qsParams.action && qsParams.action == 'stripe-setup-complete') {
                    await dispatch(completeConnectedAccountSetup())
                }
            } else {
                await dispatch(reloadAuthAccount())
                await dispatch(getActiveClassyConnections())
                const qsParams = queryString.parse(window.location.search.split('#')[0])
                if (qsParams.action && qsParams.action == 'stripe-setup-complete') {
                    await dispatch(completeConnectedAccountSetup())
                }
            }
        })()
    }, [])

    useEffect(() => {

    }, [])

    return (
        <div className="p-5 d-flex flex-column justify-content-start mb-5">
            <div className="d-flex flex-row justify-content-between w-100">
                <Typography variant="h3">Integrations</Typography>
            </div>

            <div className="row">
                <div className="col-12 col-lg-4 mt-5">
                    <div className="d-flex flex-column justify-content-between align-items-center bg-white rounded p-4 shadow h-100">
                        <div className="d-flex flex-column justify-content-center align-items-center">
                            <img src={stripeLogo} style={{ width: '100%', height: 60, objectFit: 'contain' }} />
                            <Typography variant="h3" className="mt-2">Payouts</Typography>
                            <Typography variant="body1" className="mt-3">Latent uses Stripe Connect to pay out campaign donations to organizations. Click the button below to mangage or set up your Stripe Connect account.</Typography>
                        </div>
                        <Button fullWidth variant="contained" sx={{ marginTop: '2rem' }} onClick={handlePayoutsLinkClick}>{selectedStaffProfile && selectedStaffProfile.organization && selectedStaffProfile.organization.stripeConnectedAccountStatus == 'complete' ? 'View Dashboard' : 'Setup Payouts'}</Button>
                    </div>
                </div>
                <div className="col-12 col-lg-4 mt-5">
                    <Badge badgeContent={<CheckIcon />} color="success" className="h-100 w-100" invisible={authAccount && authAccount.selectedStaffProfile && authAccount.selectedStaffProfile && authAccount.selectedStaffProfile.nylasCalendarToken == null ? true : false}>
                        <div className="d-flex flex-column justify-content-between align-items-center bg-white rounded p-4 shadow h-100">
                            <div className="d-flex flex-column justify-content-center align-items-center">
                                <CalendarMonthIcon sx={{ fontSize: 60 }} color="primary" />
                                <Typography variant="h3" className="mt-2">Calendar</Typography>
                                <Typography variant="body1" className="mt-3">Use your Organization's existing calendars to manage and schedule Discovery Calls for your Latent Campaigns.</Typography>
                            </div>
                            <Button fullWidth variant="contained" sx={{ marginTop: '2rem' }} onClick={() => { history.push('/admin/calendar') }}>Go to Calendar</Button>
                        </div>
                    </Badge>
                </div>
                <div className="col-12 col-lg-4 mt-5">
                    <Badge badgeContent={<CheckIcon />} color="success" className="h-100 w-100" invisible={activeClassyConnections && activeClassyConnections.length == 0 ? true : false}>
                        <div className="d-flex flex-column justify-content-between align-items-center bg-white rounded p-4 shadow h-100">
                            <div className="d-flex flex-column justify-content-center align-items-center">
                                <img src={classyLogo} style={{ width: '100%', height: 60, objectFit: 'contain' }} />
                                <Typography variant="h3" className="mt-2">External Processor</Typography>
                                <Typography variant="body1" className="mt-3">The Classy integration for Latent lets you use Classy as your payment processor for Latent Campaigns. Certain limitations currently exist for this integration.</Typography>
                            </div>
                            <Button fullWidth variant="contained" sx={{ marginTop: '2rem' }} onClick={() => { history.push('/admin/integrations/classy') }}>Setup Classy</Button>
                        </div>
                    </Badge>
                </div>
                <div className="col-12 col-lg-4 mt-5">
                    <div className="d-flex flex-column justify-content-between align-items-center bg-white rounded p-4 shadow h-100">
                        <div className="d-flex flex-column justify-content-center align-items-center">
                            <img src={salesforceLogo} style={{ width: '100%', height: 60, objectFit: 'contain' }} />
                            <Typography variant="h3" className="mt-2">Donation Export</Typography>
                            <Typography variant="body1" className="mt-3">Export your donation data to Salesforce for easy integration with your existing workflows.</Typography>
                        </div>
                        <Button disabled fullWidth variant="contained" sx={{ marginTop: '2rem' }} onClick={handlePayoutsLinkClick}>Coming soon</Button>
                    </div>
                </div>
                <div className="col-12 col-lg-4 mt-5">
                    <div className="d-flex flex-column justify-content-between align-items-center bg-white rounded p-4 shadow h-100">
                        <div className="d-flex flex-column justify-content-center align-items-center">
                            <img src={zapierLogo} style={{ width: '100%', height: 60, objectFit: 'contain' }} />
                            <Typography variant="h3" className="mt-2">Automation Integrations</Typography>
                            <Typography variant="body1" className="mt-3">Connect to over 4000+ existing applications with our Zapier integration. Use Zapier to quickly connect Latent to a large network of products and services you already use.</Typography>
                        </div>
                        <Button disabled fullWidth variant="contained" sx={{ marginTop: '2rem' }} onClick={handlePayoutsLinkClick}>Coming soon</Button>
                    </div>
                </div>
                <div className="col-12 col-lg-4 mt-5">
                    <div className="d-flex flex-column justify-content-between align-items-center bg-white rounded p-4 shadow h-100">
                        <div className="d-flex flex-column justify-content-center align-items-center">
                            <img src={networkForGoodLogo} style={{ width: '100%', height: 60, objectFit: 'contain' }} />
                            <Typography variant="h3" className="mt-2">Donor Journeys</Typography>
                            <Typography variant="body1" className="mt-3">Use your existing workflows with new donors you acquire through Latent. Make sure you don't leave any of your new donors unconnected with this critical integration.</Typography>
                        </div>
                        <Button disabled fullWidth variant="contained" sx={{ marginTop: '2rem' }} onClick={handlePayoutsLinkClick}>Coming soon</Button>
                    </div>
                </div>
            </div>



            {/* DIALOG */}


        </div>
    )
}